import { Action } from '../../actions/core/action';
import { ILogService } from 'angular';
import ActionDispatcherService from '../../actions/core/action-dispatcher.service';
import { ActionHandler } from '../../actions/core/action-handler';
import NotificationService from '../notification/notification.service';
import { GenericError, MasterPassError } from './error.action';
import GoogleAnalyticsService from '../analytics/google-analytics.service';

/* @ngInject */
export default class ErrorMessageHandler implements ActionHandler {
  private disableErrorCode: number[];
  constructor(
    private actionDispatcher: ActionDispatcherService,
    private notificationService: NotificationService,
    private i18n,
    private $log: ILogService,
    private googleAnalytics: GoogleAnalyticsService,

    config
  ) {
    this.disableErrorCode = config.disableErrorCode;
  }

  public $onInit() {
    this.actionDispatcher.register(this);
  }

  public handle(action: Action) {
    if (action instanceof GenericError) {
      if(action.error){
        this.googleAnalytics.setError(action.error);

      }

      let code =
        !!action.error && !!action.error.code ? action.error.code : 'default';
      if (code !== 'default' && this.checkDontAllowErrorMessage(action.error.code)) {
        this.$log.info(
          `Disabled Error ${action.error.code} occurred: ${action.error.message} (${action.error.detailMessage})`
        );
        return;
      }
      let message = this.i18n.getTranslation(`error.message.${code}`);

      if (message === `error.message.${code}`) {
        if(!!action.isPayment && code > 100000){
          message = this.i18n.getTranslation(`error.message.1XXXXX`);
        } else{
          message = undefined;
        }
      } 

      message = message || action.error.message;
      
      if (!message || message.trim().split(' ').length < 2) {
        message = this.i18n.getTranslation('error.message.default');
      }

      /*if(action && action.error && action.error.message) {
        message = action.error.message + ":::" + action.error.code;
      } */
      

      if (message) {
        this.notificationService.showNotification({
          text: message,
          type: 'warning'
        });
      }
    } else if(action instanceof MasterPassError) {
      let message = this.i18n.getTranslation(`error.message.${action.errorCode}`);

      if (message === `error.message.${action.errorCode}`) {
        message = action.errorMessage;
      }

      if (!message || message.trim().split(' ').length < 2) {
        message = this.i18n.getTranslation('error.message.default');
      }

      if (message) {
        this.notificationService.showNotification({
          text: message,
          type: 'warning'
        });
      }

    }
  }

  public checkDontAllowErrorMessage(code: number) {
    if (this.disableErrorCode && (this.disableErrorCode.indexOf(code) > -1)) {
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/error/error.message.handler.ts